import React from "react";
import {useTheme} from "@emotion/react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

interface IProps extends IIcon {
    secondaryFill?: string;
}

export const MapMarkerFillIcon = (props: IProps) => {
    const theme = useTheme();

    return (
        <SvgIcon {...props}>
            <path
                d="M3 5.5C3.5 6.349 4 7.045 5 9c.4-.732 1.02-2.004 1.5-2.443.6-.549 1-.96 1-2.057s.1-.903-.5-2-.8-1.319-1.999-1.319c-1.2 0-.201-.307-1.501.319C2.424 2.018 2 3.45 2 4c0 .549.44.55 1 1.5Z"
                fill={props.secondaryFill || theme.colors.primary}
            />
            <path d="M4.977 1A2.976 2.976 0 0 0 2.69 5.882L4.641 8.54l.336.46 2.234-3.05A2.976 2.976 0 0 0 4.977 1Zm0 7.08L4.032 6.8 3.11 5.539l-.035-.046a2.438 2.438 0 1 1 3.805 0l-.008-.005L5.909 6.8l-.932 1.28Z" />
            <path d="M5.044 4.87a.976.976 0 1 0 0-1.952.976.976 0 0 0 0 1.952Z" />
        </SvgIcon>
    );
};
